import {
    createUnifiedTheme,
    genPageTheme,
    palettes,
    shapes,
  } from '@backstage/theme';
  
  export const speedyTheme = createUnifiedTheme({
    palette: {
      ...palettes.light,
  
      /* Primary & Secondary Colors */
      primary: {
        main: '#89bcdb', // Parcels Primary
      },
      secondary: {
        main: '#7562a6', // Fulfil Primary
      },
  
      /* UI Colors */
      error: {
        main: '#da291c',
      },
      warning: {
        main: '#8f5e15',
      },
      info: {
        main: '#35abe2',
      },
      success: {
        main: '#40ab3d',
      },
  
      /* Background & Foreground */
      background: {
        default: '#f1f2f2', // Light Gray
        paper: '#ffffff',
      },
      text: {
        primary: '#363636', // Brand Gray Dark
        secondary: '#656565', // Mid Dark Gray
      },
  
      /* Navigation (Sidebar) */
      navigation: {
        submenu: {
          background: '#35abe2',
        },
        background: '#f4f4f4',
        indicator: '#9d599f',
        selectedColor: '#9d599f',
        color: '#0d456b',
        navItem: {
          hoverBackground: '#35abe2',
        },
      },
  
    },
  
    /* Page Themes */
    pageTheme: {
      home: genPageTheme({ colors: ['#0d456b', '#9d599f'], shape: shapes.wave }),
      documentation: genPageTheme({ colors: ['#0d456b', '#9d599f'], shape: shapes.wave }),
      project: genPageTheme({ colors: ['#0d456b', '#0d456b'], shape: shapes.wave }),
      tool: genPageTheme({ colors: ['#9d599f', '#9d599f'], shape: shapes.round }),
      library: genPageTheme({ colors: ['#9d599f', '#9d599f'], shape: shapes.round }),
      technique: genPageTheme({ colors: ['#9d599f', '#9d599f'], shape: shapes.round }),
      other: genPageTheme({ colors: ['#0d456b', '#9d599f'], shape: shapes.wave }),
      apis: genPageTheme({ colors: ['#0d456b', '#9d599f'], shape: shapes.wave }),
    },
    
    /* Font Settings */
    fontFamily: '"DIN OT", Helvetica, Arial, sans-serif',
  
    /* Component Customizations */
    components: {
      BackstageInfoCard: {
        styleOverrides: {

        },
      },
      BackstageSidebar: {
        styleOverrides: {
          drawer: {
            borderRight: '1px solid #d9d9d9',
            backgroundColor: '#d9d9d9',
          },
        },
      },
      BackstageSidebarItem: {
        styleOverrides: {
          root: {
            textDecorationLine: 'none',
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: `
          @font-face {
            font-family: 'DIN OT';
            src: url('../fonts/DINOT-Light.ttf') format('TrueType');
            font-weight: 300;
            font-style: normal;
          }
  
          @font-face {
            font-family: 'DIN OT';
            src: url('../fonts/DINOT.ttf') format('TrueType');
            font-weight: 400;
            font-style: normal;
          }
  
          @font-face {
            font-family: 'DIN OT';
            src: url('../fonts/DINOT-Medium.ttf') format('TrueType');
            font-weight: 500;
            font-style: normal;
          }
  
          @font-face {
            font-family: 'DIN OT';
            src: url('../fonts/DINOT-Bold.ttf') format('TrueType');
            font-weight: 700;
            font-style: normal;
          }
  
          /* Apply Default Text Color */
          body {
            color: #363636;
          }
  
          p {
            color: #363636;
          }
  
          /* Hide Scrollbar */
          ::-webkit-scrollbar {
            display: none;
          }
  
          /* Tooltip */
          .tooltip::after {
            position: absolute;
            z-index: 1;
            content: attr(data-title);
            top: calc(100% + 3px);
            left: 50%;
            transform: translate(-50%);
            background-color: #f1f2f2;
            color: #363636;
            padding: 4px 8px;
            text-align: center;
            font-size: 10px;
            font-weight: medium;
            border-radius: 4px;
            opacity: 0;
            visibility: hidden;
            white-space: nowrap;
            box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.2);
          }
  
          .tooltip:hover::after {
            opacity: 1;
            visibility: visible;
          }
        `,
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
          },
          containedPrimary: {
            '&:hover': {
              backgroundColor: '#35abe2',
            },
            color: '#FFFFFF',
          },
          containedSecondary: {
            '&:hover': {
              backgroundColor: '#35abe2',
            },
            color: '#FFFFFF',
          },
        },
      },
    },
  });
  